import Box from '@mui/material/Box';
import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import Typography from '@mui/material/Typography'

const PreviewBulkSentEmail = ({ detail = {} }) => (
  <Box className='pt-4'>
    <TableContainer component={Box} style={{ maxHeight: '40vh' }}>
      <Table>
        <TableBody>
          {detail.users?.map((user, index) => (
            <TableRow key={`table-columd-body-${user._id}-${index}`}>
              <TableCell width={80}>
                <Typography
                  component={'p'}
                  color='primary'
                  variant='inherit'
                  className='text-sm py-1 font-bold'
                >
                  {user.email}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography component={'b'} variant='inherit' className='text-xs py-1 px-2 uppercase font-bold overflow-hidden'>
                  {user.status}
                </Typography>
              </TableCell>
              <TableCell>
              <Typography component={'span'} variant='inherit' className='text-sm py-1 overflow-hidden'>
                  {user.message}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
);

export default PreviewBulkSentEmail;
